import { Checkbox, Field, NumericInput, RadioGroup, TextInput, TextOutput } from '../../../../Core';
import { FieldSet, ListFieldSection, SectionGroup } from '../../../../Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../Core/types';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { pipe } from 'Lib/Hooks/Selectors';
import { Guid } from 'Lib/Guid';
import { valueOrDefault } from 'Lib/Any';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';
import { DisplacementGaugeOrientation } from 'Components/Worksheets/PlateLoadingWorksheet/types';
import EquipmentPlateFieldSet from '../../Sections/Equipment/EquipmentPlateFieldSet';
import { EquipmentDisplacementGaugeFieldSet, EquipmentJackFieldSet, EquipmentLoadCellFieldSet } from '../../Sections';

let EquipmentDetailsSectionBase = ({ createWorksheetSelector }: IWorksheetComponent): JSX.Element => {
  const thermometerId = useSelector(createWorksheetSelector!('Thermometer.Id')) as Guid;
  const timerId = useSelector(createWorksheetSelector!('Timer.Id')) as Guid;
  const useAdditionalPlate = useSelector(pipe(createWorksheetSelector!('UseAdditionalPlate'), valueOrDefault(false)));
  const applyEquipmentLoadToReadings = useSelector(
    pipe(createWorksheetSelector!('data.Preparation.ApplyEquipmentLoadToReadings', false), valueOrDefault(false))
  );

  return (
    <SectionGroup heading="Equipment Details">
      <ListFieldSection>
        <Field input={<Checkbox />} name="UseAdditionalPlate" />
      </ListFieldSection>
      <ListFieldSection>
        <NamePrefixModifier appendNamePrefix="Plate1">
          <EquipmentPlateFieldSet />
        </NamePrefixModifier>
        <NamePrefixModifier appendNamePrefix="Plate2">
          <EquipmentPlateFieldSet visible={useAdditionalPlate} />
        </NamePrefixModifier>
        <EquipmentJackFieldSet />
        <WorksheetBalanceFieldSet name="Balance" />
        <EquipmentLoadCellFieldSet />
        <NamePrefixModifier namePrefix="data.Preparation">
          <Field input={<NumericInput />} name="AdditionalEquipmentMass" />
          <FieldSet>
            <Field input={<Checkbox />} name="ApplyEquipmentLoadToReadings" />
            <Field input={<TextOutput />} name="CombinedEquipmentLoad" visible={applyEquipmentLoadToReadings} />
          </FieldSet>
        </NamePrefixModifier>
        <EquipmentDisplacementGaugeFieldSet name="DisplacementGauge1" />
        <EquipmentDisplacementGaugeFieldSet name="DisplacementGauge2" />
        <EquipmentDisplacementGaugeFieldSet name="DisplacementGauge3" />
        <Field
          input={<RadioGroup />}
          name="DisplacementGaugeOrientation"
          options={[
            { label: 'Decrease', value: DisplacementGaugeOrientation.ReadingsDecreaseAsSettlementIncreases },
            { label: 'Increase', value: DisplacementGaugeOrientation.ReadingsIncreaseAsSettlementIncreases },
          ]}
        />

        <NamePrefixModifier namePrefix="data.Preparation">
          <Field
            input={<RadioGroup />}
            name="PlateBeddingMaterial"
            options={['Sand', 'Plaster', 'None'].map((e) => ({ label: e, value: e }))}
          />
        </NamePrefixModifier>
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="timer"
          name="Timer"
          importedCalibration={{}}
          importModel={{ Id: timerId }}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="thermometer"
          name="Thermometer"
          importedCalibration={{}}
          importModel={{ Id: thermometerId }}
        />

        <NamePrefixModifier namePrefix="data.Preparation">
          <Field input={<TextInput />} name="ReactionLoad" maxLength={50} />
        </NamePrefixModifier>
      </ListFieldSection>
    </SectionGroup>
  );
};

const EquipmentDetailsSection = withInjectedProps(EquipmentDetailsSectionBase);
export { EquipmentDetailsSection };
export default EquipmentDetailsSection;
